"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicePaymentOptionClient = exports.InvoiceClient = exports.IncomingInvoiceClient = exports.IncomingInvoiceBookingTipClient = exports.ImageClient = exports.HoldingRegisterClient = exports.GenericDocumentClient = exports.GenericCommentClient = exports.FinancialReportsClient = exports.FilterClient = exports.FileClient = exports.FeatureClient = exports.FAQServiceClient = exports.ExportItemsClient = exports.EmployeesClient = exports.EarlyPayoutClient = exports.DocumentDraftClient = exports.DocumentClient = exports.DocumentationLogClient = exports.DimensionTypesClient = exports.DimensionsReportClient = exports.DimensionPresetClient = exports.DimensionClient = exports.DiagnosticsClient = exports.DeclarationClient = exports.DeadlineClient = exports.CustomerFeedbackClient = exports.CustomerClient = exports.CurrencyClient = exports.CostForwardingClient = exports.CompanyClient = exports.CompanyAuthClient = exports.CompactReportsClient = exports.CommissionSalaryReportClient = exports.CashReconciliationClient = exports.BusinessUnitsClient = exports.BenefitClient = exports.BankIdSignClient = exports.BankIdAuthClient = exports.BankBalanceClient = exports.AuthClient = exports.AuditClient = exports.ArticleClient = exports.AnnualAccountsClient = exports.AgreementClient = exports.AgingIncomingInvoiceClient = exports.AgentSaleClient = exports.AccountClient = exports.SalaryDraftsClient = exports.PersonSalaryClient = void 0;
exports.UtilsClient = exports.UserClient = exports.UserApiKeyClient = exports.UnitClient = exports.TransactionClient = exports.TodoClient = exports.TimeReportingProjectClient = exports.TimeReportClient = exports.SurveyClient = exports.SupportTeamClient = exports.SupportClient = exports.SupportCategoryClient = exports.SupportAgentClient = exports.SupplementaryMaterialsClient = exports.StoppedPaymentClient = exports.SkattekontoClient = exports.ShareRegisterClient = exports.SettingsClient = exports.SeriesClient = exports.SelfInvoiceClient = exports.SearchClient = exports.SalarySpecificationDocumentClient = exports.SalaryImportClient = exports.SalaryDeviationClient = exports.SalaryClient = exports.RevenueReportingClient = exports.ReportWidgetClient = exports.ReportClient = exports.ReferenceClient = exports.RecurringInvoiceClient = exports.ReceiptReportClient = exports.ReceiptPaymentMethodClient = exports.ReceiptClient = exports.ReceiptCategoryClient = exports.QuotationClient = exports.QualifiedShareDividendClient = exports.ProfileRoutineClient = exports.ProfileImagesClient = exports.PreliminaryTaxUpdateClient = exports.PingClient = exports.PaymentClient = exports.OnboardingTestSessionClient = exports.OnboardingBankIdAuthClient = exports.OffboardingBankIdAuthClient = exports.NotificationClient = exports.NewsArticlesClient = exports.MonthlyReportsClient = exports.MissingDocumentClient = exports.LoggingClient = exports.LeadClient = void 0;
exports.ReceiptAutomationRuleClient = exports.AutomationRuleClient = exports.WintSalaryDeviationClient = exports.WintSalaryClient = exports.WintSalaryCommissionClient = exports.WintCardClient = exports.WarmUpClient = exports.VoucherImagesClient = exports.VoucherClient = exports.VatReportsClient = void 0;
const baseClient_1 = require("./baseClient");
class PersonSalaryClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetUpdatedPersonSalaryRow = (salaryEntryId, request, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/UpdatedRow/${salaryEntryId}`, request, undefined, config);
        };
        this.GetPersonSalaryReport = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/PersonSalaryReport`, undefined, undefined, config);
        };
        this.Approve = (salariesToApprove, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Approve`, salariesToApprove, undefined, config);
        };
        this.GetSalaryEntries = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.DownloadSalarySpecificationDocument = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SalarySpecificationDocument/${id}`, undefined, undefined, config);
        };
        this.PostExtraSalary = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ExtraSalary`, post, undefined, config);
        };
        this.PredictExtraSalaryInfo = (grossAmount, employeeId, isHandledByWint, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/PredictExtraSalaryInfo`, { grossAmount: grossAmount, employeeId: employeeId, isHandledByWint: isHandledByWint }, undefined, config);
        };
        this.GetSearchEmployeeByName = (searchStr, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SearchByName`, { searchStr: searchStr }, undefined, config);
        };
    }
}
exports.PersonSalaryClient = PersonSalaryClient;
class SalaryDraftsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetSalaryDrafts = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetSalaryDraft = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetAttachment = (id, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/attachment/${attachmentId}`, undefined, undefined, config);
        };
        this.DownloadAttachment = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/download`, undefined, undefined, config);
        };
        this.Put = (id, salaryDraftPut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, salaryDraftPut, undefined, config);
        };
        this.Accept = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Accept`, undefined, undefined, config);
        };
        this.Reject = (id, rejectAction, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Reject`, rejectAction, undefined, config);
        };
        this.Assign = (id, assignAction, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Assign`, assignAction, undefined, config);
        };
        this.SearchSalaryAdmins = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SearchSalaryAdmins`, filter, undefined, config);
        };
    }
}
exports.SalaryDraftsClient = SalaryDraftsClient;
class AccountClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetAccountBalance = (account, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AccountBalance/${account}`, undefined, undefined, config);
        };
        this.GetAccountingDoneUntilMonth = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AccountingDoneUntil`, undefined, undefined, config);
        };
        this.GetRevenueAccounts = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/RevenueAccounts`, undefined, undefined, config);
        };
    }
}
exports.AccountClient = AccountClient;
class AgentSaleClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Put = (externalId, sale, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${externalId}`, sale, undefined, config);
        };
        this.Get = (externalId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${externalId}`, undefined, undefined, config);
        };
    }
}
exports.AgentSaleClient = AgentSaleClient;
class AgingIncomingInvoiceClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.UpdateAgingIncomingInvoice = (updateInfo, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}`, updateInfo, undefined, config);
        };
    }
}
exports.AgingIncomingInvoiceClient = AgingIncomingInvoiceClient;
class AgreementClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Post = (agreement, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, agreement, undefined, config);
        };
        this.Update = (agreement, id, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, agreement, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.AgreementClient = AgreementClient;
class AnnualAccountsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Approve = (financialYearId, approve, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${financialYearId}/Approve`, approve, undefined, config);
        };
        this.Reject = (financialYearId, reject, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${financialYearId}/Reject`, reject, undefined, config);
        };
        this.Comment = (financialYearId, comment, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${financialYearId}/Comment`, comment, undefined, config);
        };
        this.OrderK10 = (financialYearId, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${financialYearId}/OrderK10`, request, undefined, config);
        };
        this.DownloadPdf = (financialYearId, reportType, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/DownloadPdf/${reportType}`, undefined, undefined, config);
        };
        this.DownloadPdfOriginal = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/DownloadPdf`, undefined, undefined, config);
        };
        this.GetFinancialStatements = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/FinancialStatements`, undefined, undefined, config);
        };
        this.GetAnnualReport = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}`, undefined, undefined, config);
        };
        this.ConfirmAuditorReportUploaded = (financialYearId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${financialYearId}/ConfirmAuditorReportUploaded`, undefined, undefined, config);
        };
        this.SetAnnualReportToHandledByAuditor = (financialYearId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${financialYearId}/SetAnnualReportToHandledByAuditor`, undefined, undefined, config);
        };
        this.GetAnnualReportTimeLine = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/TimeLine`, undefined, undefined, config);
        };
        this.GetAuditorAssistants = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/AuditorAssistants`, undefined, undefined, config);
        };
        this.UpdateAuditorAssistants = (financialYearId, request, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${financialYearId}/AuditorAssistants`, request, undefined, config);
        };
        this.ConfirmedAuditorReportSigned = (financialYearId, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${financialYearId}/ConfirmedAuditorReportSigned`, request, undefined, config);
        };
        this.GetFinancialStatementsApprovalSignees = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/FinancialStatementsApprovalSignees`, undefined, undefined, config);
        };
        this.DownloadTaxCalculationReportForFinancialYear = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/GetTaxCalculationReportPdf`, undefined, undefined, config);
        };
        this.GetDocumentsMeta = (financialYearId, reportType, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/DocumentsMeta/${reportType}`, undefined, undefined, config);
        };
        this.GetDocumentPdf = (financialYearId, reportType, preview, dividend, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/Document/${reportType}`, { preview: preview, dividend: dividend }, undefined, config);
        };
        this.GetDividendsInfoAsync = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/DividendInformation`, undefined, undefined, config);
        };
        this.GetK10Prerequisites = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/K10Prerequisites`, undefined, undefined, config);
        };
    }
}
exports.AnnualAccountsClient = AnnualAccountsClient;
class ArticleClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Post = (article, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, article, undefined, config);
        };
        this.Put = (id, article, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, article, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Activate = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Activate/${id}`, undefined, undefined, config);
        };
        this.Deactivate = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Deactivate/${id}`, undefined, undefined, config);
        };
        this.SearchArticle = (searchName, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SearchByName`, { searchName: searchName }, undefined, config);
        };
        this.TopArticle = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Common`, undefined, undefined, config);
        };
        this.ImportArticles = (request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ImportArticles`, request, undefined, config);
        };
    }
}
exports.ArticleClient = ArticleClient;
class AuditClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetAuditSheetPdfAsync = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AuditSheet/${id}`, undefined, undefined, config);
        };
        this.GetFullAuditSheetPdfAsync = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AuditSheet/Full/${id}`, undefined, undefined, config);
        };
        this.GetAuditSheetDetails = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AuditSheet/Details/${id}`, undefined, undefined, config);
        };
        this.GetAttachment = (auditSheetId, attachmentId, wintAccountingVoucherId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AuditSheet/${auditSheetId}/Attachment/${attachmentId}`, { wintAccountingVoucherId: wintAccountingVoucherId }, undefined, config);
        };
    }
}
exports.AuditClient = AuditClient;
class AuthClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Post = (auth, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, auth, undefined, config);
        };
        this.PostJwt = (auth, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/jwt`, auth, undefined, config);
        };
        this.PostTicket = (ticket, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ticket`, ticket, undefined, config);
        };
        this.RefreshToken = (refreshToken, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/refresh`, refreshToken, undefined, config);
        };
        this.Get = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, undefined, undefined, config);
        };
        this.ForgotPassword = (forgotPassword, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ForgotPassword`, forgotPassword, undefined, config);
        };
        this.ResetPassword = (resetPassword, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ResetPassword`, resetPassword, undefined, config);
        };
    }
}
exports.AuthClient = AuthClient;
class BankBalanceClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetDashboardBalances = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/dashboard`, undefined, undefined, config);
        };
        this.GetVisibilitySettings = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/settings`, undefined, undefined, config);
        };
        this.UpdateVisibilitySettings = (changes, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/settings`, changes, undefined, config);
        };
    }
}
exports.BankBalanceClient = BankBalanceClient;
class BankIdAuthClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Post = (auth, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, auth, undefined, config);
        };
        this.PostJwt = (auth, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/jwt`, auth, undefined, config);
        };
        this.BeginLogin = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/start`, undefined, undefined, config);
        };
        this.CheckLoginStatus = (token, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${token}`, undefined, undefined, config);
        };
        this.CheckLoginStatusJwt = (token, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/jwt/${token}`, undefined, undefined, config);
        };
    }
}
exports.BankIdAuthClient = BankIdAuthClient;
class BankIdSignClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.SignPayments = (signPaymentsPost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SignPayments`, signPaymentsPost, undefined, config);
        };
        this.SignPaymentsBegin = (signPaymentsPost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SignPayments/begin`, signPaymentsPost, undefined, config);
        };
        this.GetPendingPaymentSigningInfo = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/PendingPaymentSigningInfo`, undefined, undefined, config);
        };
    }
}
exports.BankIdSignClient = BankIdSignClient;
class BenefitClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.CreateBenefit = (createRequest, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, createRequest, undefined, config);
        };
        this.Report = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Report`, filter, undefined, config);
        };
        this.GetBenefitById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.UpdateBenefit = (id, updateRequest, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, updateRequest, undefined, config);
        };
        this.CreateBenefitMutable = (createRequest, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/mutable`, createRequest, undefined, config);
        };
        this.UpdateBenefitMutable = (id, updateRequest, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/mutable/${id}`, updateRequest, undefined, config);
        };
        this.GetBrandsAndManufacturingYears = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/BrandsAndManufacturingYears`, undefined, undefined, config);
        };
        this.GetCarBenefitModels = (vehicleType, brand, manufacturingYear, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CarBenefitModels/${vehicleType}`, { brand: brand, manufacturingYear: manufacturingYear }, undefined, config);
        };
        this.CalculateCarBenefitAmount = (vehicleTax, modelNumber, taxationYear, extraEquipmentCost, annualMileage, firstRegistrationDate, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CarBenefitAmount`, { vehicleTax: vehicleTax, modelNumber: modelNumber, taxationYear: taxationYear, extraEquipmentCost: extraEquipmentCost, annualMileage: annualMileage, firstRegistrationDate: firstRegistrationDate }, undefined, config);
        };
    }
}
exports.BenefitClient = BenefitClient;
class BusinessUnitsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Report = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Report`, filter, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Managers = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Managers`, filter, undefined, config);
        };
        this.Post = (businessUnit, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, businessUnit, undefined, config);
        };
        this.Put = (id, businessUnit, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, businessUnit, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.AvailablePersons = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AvailablePersons`, filter, undefined, config);
        };
    }
}
exports.BusinessUnitsClient = BusinessUnitsClient;
class CashReconciliationClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetTemplate = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/template`, undefined, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetAttachment = (id, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/attachment/${attachmentId !== undefined ? attachmentId : ''}`, undefined, undefined, config);
        };
        this.UpdateAttachment = (id, attachment, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}/attachment`, attachment, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.Post = (dto, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, dto, undefined, config);
        };
        this.Put = (id, dto, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, dto, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetStateLogs = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/StateLogs`, undefined, undefined, config);
        };
        this.GetTransactions = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Transactions`, undefined, undefined, config);
        };
    }
}
exports.CashReconciliationClient = CashReconciliationClient;
class CommissionSalaryReportClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetEmployeeTransactions = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/transactions`, filter, undefined, config);
        };
        this.GetMine = (year, month, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/mine/${year}/${month}`, undefined, undefined, config);
        };
    }
}
exports.CommissionSalaryReportClient = CommissionSalaryReportClient;
class CompactReportsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.CompactReportsClient = CompactReportsClient;
class CompanyAuthClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Post = (auth, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, auth, undefined, config);
        };
    }
}
exports.CompanyAuthClient = CompanyAuthClient;
class CompanyClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetSelectedCompanyId = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Selected`, undefined, undefined, config);
        };
        this.SetSelectedCompanyId = (selectedCompany, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Selected`, selectedCompany, undefined, config);
        };
        this.SearchPersons = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SearchPersons`, filter, undefined, config);
        };
        this.GetEmployee = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Employee/${id}`, undefined, undefined, config);
        };
        this.GetEmployees = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Employees`, filter, undefined, config);
        };
        this.GetEmailAddresses = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/EmailAddresses`, undefined, undefined, config);
        };
        this.GetCompanyDirectors = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Directors`, undefined, undefined, config);
        };
        this.UpdateDirectorExtraData = (id, directors, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}/Directors`, directors, undefined, config);
        };
        this.GetExternalCompanyInformation = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/ExternalCompanyInformation`, undefined, undefined, config);
        };
        this.GetAvailableSalaryTypes = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/AvailableSalaryTypes`, undefined, undefined, config);
        };
    }
}
exports.CompanyClient = CompanyClient;
class CostForwardingClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Forwardable = (customerId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/forwardable`, { customerId: customerId }, undefined, config);
        };
        this.GetForReceipt = (receiptId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/receipt/${receiptId}`, undefined, undefined, config);
        };
        this.SetForReceipt = (receiptId, marking, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/receipt/${receiptId}`, marking, undefined, config);
        };
        this.GetForIncomingInvoice = (incomingInvoiceId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/incominginvoice/${incomingInvoiceId}`, undefined, undefined, config);
        };
        this.SetForIncomingInvoice = (incomingInvoiceId, marking, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/incominginvoice/${incomingInvoiceId}`, marking, undefined, config);
        };
        this.Release = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/release`, undefined, undefined, config);
        };
    }
}
exports.CostForwardingClient = CostForwardingClient;
class CurrencyClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (currency, date, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${currency}`, { date: date }, undefined, config);
        };
    }
}
exports.CurrencyClient = CurrencyClient;
class CustomerClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GlnLookup = (organisationNumber, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GlnLookup`, { organisationNumber: organisationNumber }, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Put = (id, customer, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, customer, undefined, config);
        };
        this.Post = (customer, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, customer, undefined, config);
        };
        this.GetSearchCustomersByName = (searchString, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SearchByName`, { searchString: searchString }, undefined, config);
        };
        this.SearchCustomersByOrgNr = (searchString, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SearchByOrgNr`, { searchString: searchString }, undefined, config);
        };
        this.GetTopCustomers = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Common`, undefined, undefined, config);
        };
        this.SearchCustomer = (searchRequestFilter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Search`, searchRequestFilter, undefined, config);
        };
        this.GetCustomerRating = (searchRequestFilter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Rating`, searchRequestFilter, undefined, config);
        };
        this.Activate = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Activate/${id}`, undefined, undefined, config);
        };
        this.Deactivate = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Deactivate/${id}`, undefined, undefined, config);
        };
        this.GetCustomerWithSameDetails = (customer, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/CustomerWithSameDetails`, customer, undefined, config);
        };
        this.PenaltyInterestType = (customerId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/{id}/PenaltyInterestType`, { customerId: customerId }, undefined, config);
        };
        this.PenaltyInterestRate = (customerId, type, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/{id}/PenaltyInterestRate`, { customerId: customerId, type: type }, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/Delete/${id}`, undefined, undefined, config);
        };
        this.ImportCustomers = (request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ImportCustomers`, request, undefined, config);
        };
    }
}
exports.CustomerClient = CustomerClient;
class CustomerFeedbackClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Put = (id, feedback, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, feedback, undefined, config);
        };
        this.Cancel = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Cancel/${id}`, undefined, undefined, config);
        };
    }
}
exports.CustomerFeedbackClient = CustomerFeedbackClient;
class DeadlineClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetMostUrgent = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/MostUrgent`, undefined, undefined, config);
        };
        this.UserNotificationSettings = (settings, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/UserNotificationSettings`, settings, undefined, config);
        };
    }
}
exports.DeadlineClient = DeadlineClient;
class DeclarationClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.SaveDeclarationDataAsync = (declaration, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SaveDeclaration`, declaration, undefined, config);
        };
    }
}
exports.DeclarationClient = DeclarationClient;
class DiagnosticsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.TrackEvent = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, post, undefined, config);
        };
    }
}
exports.DiagnosticsClient = DiagnosticsClient;
class DimensionClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetDimensionsForInvoice = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Invoices`, undefined, undefined, config);
        };
        this.GetDimensionsForIncomingInvoice = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/IncomingInvoices`, undefined, undefined, config);
        };
        this.GetDimensionsForReceipts = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Receipts`, undefined, undefined, config);
        };
        this.Post = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, post, undefined, config);
        };
        this.Put = (id, put, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, put, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
    }
}
exports.DimensionClient = DimensionClient;
class DimensionPresetClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.Post = (dimensionPreset, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, dimensionPreset, undefined, config);
        };
    }
}
exports.DimensionPresetClient = DimensionPresetClient;
class DimensionsReportClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.DimensionsReportClient = DimensionsReportClient;
class DimensionTypesClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetDimensionTypesForIncomingInvoice = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/IncomingInvoices`, undefined, undefined, config);
        };
        this.GetDimensionTypesForInvoice = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Invoices`, undefined, undefined, config);
        };
        this.GetDimensionTypesForReceipts = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Receipts`, undefined, undefined, config);
        };
    }
}
exports.DimensionTypesClient = DimensionTypesClient;
class DocumentationLogClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetAll = (companyId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Company/${companyId}`, undefined, undefined, config);
        };
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetByAuthorId = (authorId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Author/${authorId}`, undefined, undefined, config);
        };
        this.GetByCustomerCaseId = (customerCaseId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CustomerCase/${customerCaseId}`, undefined, undefined, config);
        };
        this.Create = (logItem, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, logItem, undefined, config);
        };
        this.Update = (logItem, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}`, logItem, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetAttachmentAsync = (documentaionLogId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${documentaionLogId}/Attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.DownloadAttachmentAsync = (documentaionLogId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${documentaionLogId}/DownloadAttachment/${attachmentId}`, undefined, undefined, config);
        };
    }
}
exports.DocumentationLogClient = DocumentationLogClient;
class DocumentClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.FilterSIEFiles = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SIEFiles`, filter, undefined, config);
        };
        this.UploadSIEFiles = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SIEFiles`, post, undefined, config);
        };
        this.ExportSIEFile = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SIEFiles/Export`, post, undefined, config);
        };
        this.QueueExportSIEFile = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SIEFiles/QueueExport`, post, undefined, config);
        };
        this.DownloadSIEFile = (id, actionType, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SIEFiles/${id}/Download`, { actionType: actionType }, undefined, config);
        };
        this.GetSharedDocuments = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SharedDocuments`, undefined, undefined, config);
        };
        this.GetSharedDocumentsByParent = (parentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SharedDocuments/${parentId}`, undefined, undefined, config);
        };
        this.DownloadSharedDocument = (id, type, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SharedDocuments/${id}/Download`, { type: type }, undefined, config);
        };
        this.UploadAdvisorDocuments = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/UploadAdvisorDocuments`, post, undefined, config);
        };
        this.ExportSharedFolderForFinancialYear = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SharedDocuments/FinancialYear/${financialYearId}/Export`, undefined, undefined, config);
        };
        this.GetSharedFolderIdForFinancialYear = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SharedDocuments/FinancialYear/${financialYearId}/FolderId`, undefined, undefined, config);
        };
    }
}
exports.DocumentClient = DocumentClient;
class DocumentDraftClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Post = (documentDraft, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, documentDraft, undefined, config);
        };
        this.GetAttachmentAsync = (documentDraftId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${documentDraftId}/Attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.Delete = (documentDraftId, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${documentDraftId}`, undefined, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.HandleRemovedDraft = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/HandleRemovedDraft`, undefined, undefined, config);
        };
    }
}
exports.DocumentDraftClient = DocumentDraftClient;
class EarlyPayoutClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetEarlyPayoutInfo = (personExternalId, yearMonth, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${personExternalId}`, { yearMonth: yearMonth }, undefined, config);
        };
        this.PreviewEarlyPayout = (request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/preview`, request, undefined, config);
        };
        this.SubmitEarlyPayout = (request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, request, undefined, config);
        };
        this.GetPayouts = (personExternalId, yearMonth, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${personExternalId}/${yearMonth}/payouts`, undefined, undefined, config);
        };
    }
}
exports.EarlyPayoutClient = EarlyPayoutClient;
class EmployeesClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetByIdAsync = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Update = (id, put, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, put, undefined, config);
        };
        this.Delete = (id, extraData, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, extraData, undefined, config);
        };
        this.Create = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, post, undefined, config);
        };
    }
}
exports.EmployeesClient = EmployeesClient;
class ExportItemsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.Post = (exportItemPost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, exportItemPost, undefined, config);
        };
        this.Download = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Download/${id}`, undefined, undefined, config);
        };
    }
}
exports.ExportItemsClient = ExportItemsClient;
class FAQServiceClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetFAQ = (searchQuery, maxItems, threshold, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, { searchQuery: searchQuery, maxItems: maxItems, threshold: threshold }, undefined, config);
        };
    }
}
exports.FAQServiceClient = FAQServiceClient;
class FeatureClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (feature, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${feature}`, undefined, undefined, config);
        };
    }
}
exports.FeatureClient = FeatureClient;
class FileClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.DownloadFileAsync = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.UploadFileAsync = (file, imageType, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, { file: file, imageType: imageType }, undefined, config);
        };
    }
}
exports.FileClient = FileClient;
class FilterClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Create = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, post, undefined, config);
        };
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Remove = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Update = (id, put, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, put, undefined, config);
        };
    }
}
exports.FilterClient = FilterClient;
class FinancialReportsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetResultReport = (filter, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ResultReport`, filter, undefined, config);
        };
        this.GetMonthlyResultReport = (filter, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/MonthlyResultReport`, filter, undefined, config);
        };
        this.GetBalanceReport = (filter, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/BalanceReport`, filter, undefined, config);
        };
        this.GetAuditBalanceReport = (filter, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Audit/BalanceReport`, filter, undefined, config);
        };
        this.GetAuditBalanceReportFilterData = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Audit/BalanceReportFilterData`, undefined, undefined, config);
        };
        this.GetMonthlyBalanceReport = (filter, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/MonthlyBalanceReport`, filter, undefined, config);
        };
        this.GetDimensionReport = (filter, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/DimensionReport`, filter, undefined, config);
        };
        this.GetMultiDimensionReport = (filter, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/MultiDimensionReport`, filter, undefined, config);
        };
        this.GetLastReconciliationIdForFinancialYear = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/LastReconciliationId`, undefined, undefined, config);
        };
    }
}
exports.FinancialReportsClient = FinancialReportsClient;
class GenericCommentClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Post = (comment, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, comment, undefined, config);
        };
        this.TopComments = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/TopComments`, undefined, undefined, config);
        };
    }
}
exports.GenericCommentClient = GenericCommentClient;
class GenericDocumentClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Post = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, post, undefined, config);
        };
        this.Update = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Update`, request, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Delete`, undefined, undefined, config);
        };
        this.Filter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetTransactions = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Transactions`, undefined, undefined, config);
        };
        this.Download = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Download`, undefined, undefined, config);
        };
        this.GetStateLogs = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/StateLogs`, undefined, undefined, config);
        };
        this.UpdateSentBackDocument = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/UpdateSentBackDocument`, request, undefined, config);
        };
        this.GetAttachmentAsync = (genericDocumentId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${genericDocumentId}/Attachments/${attachmentId}`, undefined, undefined, config);
        };
    }
}
exports.GenericDocumentClient = GenericDocumentClient;
class HoldingRegisterClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetAssets = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetAssets`, filter, undefined, config);
        };
    }
}
exports.HoldingRegisterClient = HoldingRegisterClient;
class ImageClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetAsyncByIdasinteger = (idAsInteger, type, page, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${idAsInteger}`, { type: type, page: page }, undefined, config);
        };
        this.GetAsyncByIdasguid = (idAsGuid, type, page, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${idAsGuid}`, { type: type, page: page }, undefined, config);
        };
        this.DownloadAsyncByIdasinteger = (idAsInteger, type, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${idAsInteger}/Download`, { type: type }, undefined, config);
        };
        this.DownloadAsyncByIdasguid = (idAsGuid, type, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${idAsGuid}/Download`, { type: type }, undefined, config);
        };
        this.GetMetaAsyncByEntityidasinteger = (entityIdAsInteger, type, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${entityIdAsInteger}/Meta`, { type: type }, undefined, config);
        };
        this.GetMetaAsyncByEntityidasguid = (entityIdAsGuid, type, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${entityIdAsGuid}/Meta`, { type: type }, undefined, config);
        };
        this.GetFileSize = (fileId, type, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/FileSize/${fileId}`, { type: type }, undefined, config);
        };
    }
}
exports.ImageClient = ImageClient;
class IncomingInvoiceBookingTipClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetBookingTreeItems = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, undefined, undefined, config);
        };
        this.SearchBookingTree = (searchText, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SearchBookingTree`, searchText, undefined, config);
        };
    }
}
exports.IncomingInvoiceBookingTipClient = IncomingInvoiceBookingTipClient;
class IncomingInvoiceClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetDimensionSuggestions = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DimensionSuggestions`, filter, undefined, config);
        };
        this.CompanyInvoiceMail = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CompanyInvoiceMail`, undefined, undefined, config);
        };
        this.Filter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.Post = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, post, undefined, config);
        };
        this.Put = (id, invoice, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, invoice, undefined, config);
        };
        this.EditPeriodisations = (id, body, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}/periodisations`, body, undefined, config);
        };
        this.GetAttachmentAsync = (incomingInvoiceId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${incomingInvoiceId}/Attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.SendToPerson = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SendToPerson/${id}`, request, undefined, config);
        };
        this.Sign = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Sign/${id}`, undefined, undefined, config);
        };
        this.UpdateAndSign = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/UpdateAndSign/${id}`, request, undefined, config);
        };
        this.Certify = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Certify/${id}`, request, undefined, config);
        };
        this.UpdateAndCertify = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/UpdateAndCertify/${id}`, request, undefined, config);
        };
        this.Cancel = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Cancel/${id}`, undefined, undefined, config);
        };
        this.ToggleAlreadyPaid = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ToggleAlreadyPaid/${id}`, request, undefined, config);
        };
        this.SendBack = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SendBack/${id}`, request, undefined, config);
        };
        this.ConvertToGenericVoucher = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/ConvertToGenericVoucher/${id}`, undefined, undefined, config);
        };
        this.GetPdf = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetPdf/${id}`, undefined, undefined, config);
        };
        this.ResumePayment = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ResumePayment/${id}`, undefined, undefined, config);
        };
        this.GetSuppliers = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Suppliers`, filter, undefined, config);
        };
        this.GetSuggestedIncomingInvoiceSuppliers = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetSuggestedIncomingInvoiceSuppliers`, undefined, undefined, config);
        };
        this.GetSupplier = (supplierId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Suppliers/${supplierId}`, undefined, undefined, config);
        };
        this.UpdateSupplier = (supplierId, supplierPut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Suppliers/${supplierId}`, supplierPut, undefined, config);
        };
        this.GetTodos = (supplierId, filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Suppliers/${supplierId}/Todos`, filter, undefined, config);
        };
        this.GetRuleById = (supplierId, ruleId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Suppliers/${supplierId}/Rule/${ruleId}`, undefined, undefined, config);
        };
        this.GetRules = (supplierId, filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Suppliers/${supplierId}/Rule`, filter, undefined, config);
        };
        this.CreateRule = (rulePost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Suppliers/Rule`, rulePost, undefined, config);
        };
        this.UpdateRule = (ruleId, rulePut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Suppliers/Rule/${ruleId}`, rulePut, undefined, config);
        };
        this.GetIncomingInvoicePersons = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetIncomingInvoicePersons`, filter, undefined, config);
        };
        this.GetSuggestedIncomingInvoicePersons = (request, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetSuggestedIncomingInvoicePersons`, request, undefined, config);
        };
        this.GetOCRCollisions = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetOCRCollisions/${id}`, undefined, undefined, config);
        };
        this.FindSimilar = (id, limit, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/FindSimilar/${id}`, { limit: limit }, undefined, config);
        };
        this.GetStateLogs = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/StateLogs/${id}`, undefined, undefined, config);
        };
        this.GetTransactions = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Transactions/${id}`, undefined, undefined, config);
        };
        this.MarkPaymentAsAlreadyPaid = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/MarkPaymentAsAlreadyPaid/${id}`, undefined, undefined, config);
        };
        this.CheckPeriodisation = (periodisationRequest, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CheckPeriodisation`, periodisationRequest, undefined, config);
        };
        this.SendEmailToSupplier = (emailProperties, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SendEmailToSupplier`, emailProperties, undefined, config);
        };
        this.GetSendSupplierEmailInfo = (incomingInvoiceId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetSendSupplierEmailInfo/${incomingInvoiceId}`, undefined, undefined, config);
        };
        this.UpdatePaymentDetails = (incomingInvoiceId, supplierPaymentDetails, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/UpdatePaymentDetails/${incomingInvoiceId}`, supplierPaymentDetails, undefined, config);
        };
        this.UpdateSupplierAddressDetails = (supplierId, supplierAddressDetails, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/UpdateSupplierAddressDetails/${supplierId}`, supplierAddressDetails, undefined, config);
        };
    }
}
exports.IncomingInvoiceClient = IncomingInvoiceClient;
class InvoiceClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetList = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/List`, filter, undefined, config);
        };
        this.GetTodos = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Todos`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetDimensionSuggestions = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DimensionSuggestions`, undefined, undefined, config);
        };
        this.Post = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, post, undefined, config);
        };
        this.Update = (id, invoicePut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, invoicePut, undefined, config);
        };
        this.EditPeriodisations = (id, body, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}/periodisations`, body, undefined, config);
        };
        this.Send = (id, options, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Send/${id}`, options, undefined, config);
        };
        this.MailInvoice = (id, options, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Mail`, options, undefined, config);
        };
        this.SendEInvoice = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/SendEInvoice`, undefined, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.WriteOffReminderFee = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/WriteOffReminderFee`, undefined, undefined, config);
        };
        this.GetTransactions = (invoiceId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${invoiceId}/transactions`, undefined, undefined, config);
        };
        this.GetAttachments = (invoiceId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${invoiceId}/attachments`, undefined, undefined, config);
        };
        this.PostAttachment = (invoiceId, post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${invoiceId}/attachments`, post, undefined, config);
        };
        this.ProspectCreated = (invoiceId, prospectCreated, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${invoiceId}/claims/notify/prospect-created`, prospectCreated, undefined, config);
        };
        this.PaymentCreated = (invoiceId, paymentCreated, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${invoiceId}/claims/notify/payment-created`, paymentCreated, undefined, config);
        };
        this.InvoiceClaimCreated = (invoiceId, invoiceClaimCreated, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${invoiceId}/claims/notify/invoice-claim-created`, invoiceClaimCreated, undefined, config);
        };
        this.PostClaim = (invoiceId, form, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${invoiceId}/claims`, form, undefined, config);
        };
        this.GetCustomerLink = (invoiceId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${invoiceId}/customerLink`, undefined, undefined, config);
        };
        this.PostAttachmentList = (invoiceId, attachmentList, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${invoiceId}/AttachmentList`, attachmentList, undefined, config);
        };
        this.GetAttachment = (invoiceId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${invoiceId}/attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.DeleteAttachment = (invoiceId, attachmentId, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${invoiceId}/attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.GetStateLogs = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/StateLogs/${id}`, undefined, undefined, config);
        };
        this.FindSimilar = (id, limit, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/FindSimilar/${id}`, { limit: limit }, undefined, config);
        };
        this.GetInvoicePdf = (id, version, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/pdf/${version !== undefined ? version : ''}`, undefined, undefined, config);
        };
        this.EditDueDate = (id, invoicePayment, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/EditDueDate/${id}`, invoicePayment, undefined, config);
        };
        this.ReportAsPaid = (id, reportPaymentRequest, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ReportAsPaid/${id}`, reportPaymentRequest, undefined, config);
        };
        this.PreviewInlineInvoicePdf = (id, version, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Preview/${version !== undefined ? version : ''}`, undefined, undefined, config);
        };
        this.InvoiceReminderPreviewPdf = (id, invoicePaymentReminder, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/ReminderPreview`, invoicePaymentReminder, undefined, config);
        };
        this.SendPaymentReminder = (id, invoicePaymentReminder, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SendPaymentReminder/${id}`, invoicePaymentReminder, undefined, config);
        };
        this.PreviewInvoicePdf = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Preview`, post, undefined, config);
        };
        this.GetWarnings = (post, invoiceId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Warnings`, post, { invoiceId: invoiceId }, config);
        };
        this.GetTopSellers = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CommonSellers`, undefined, undefined, config);
        };
        this.UpdateDimensions = (invoiceId, dimensionPut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${invoiceId}/UpdateDimension`, dimensionPut, undefined, config);
        };
        this.GetCreditInvoice = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/CreateCreditInvoice`, undefined, undefined, config);
        };
        this.GetCreditAndReissueChanges = (id, post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/CreditAndReissue/Changes`, post, undefined, config);
        };
        this.CreditAndReissue = (id, post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/CreditAndReissue`, post, undefined, config);
        };
        this.DownloadInvoicePdf = (id, version, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/downloadPDF/${version !== undefined ? version : ''}`, undefined, undefined, config);
        };
        this.GetDefaultMailOptions = (request, invoiceId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DefaultMailOptions/${invoiceId}`, request, undefined, config);
        };
        this.GetReccuringFromInvoice = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/CreateRecurringInvoice`, undefined, undefined, config);
        };
        this.GetInvoicePersons = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetInvoicePersons`, filter, undefined, config);
        };
        this.GetInvoicePersonSuggestions = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetInvoicePersonSuggestions`, filter, undefined, config);
        };
        this.ReassignOwner = (id, request, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}/ReassignOwner`, request, undefined, config);
        };
        this.GetRutRotWorkTypes = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/RutRotWorkTypes`, filter, undefined, config);
        };
        this.DisableAutomaticReminders = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/DisableAutomaticReminders/${id}`, undefined, undefined, config);
        };
        this.GetCopiedInvoice = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Copy`, undefined, undefined, config);
        };
        this.GetInvoiceVersions = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Versions`, undefined, undefined, config);
        };
        this.Activate = (invoiceActivationRequest, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Activate`, invoiceActivationRequest, undefined, config);
        };
        this.GetNextCompanyInvoiceSerialNumber = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetNextCompanyInvoiceSerialNumber`, undefined, undefined, config);
        };
    }
}
exports.InvoiceClient = InvoiceClient;
class InvoicePaymentOptionClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.InvoicePaymentOptionClient = InvoicePaymentOptionClient;
class LeadClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Post = (lead, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, lead, undefined, config);
        };
    }
}
exports.LeadClient = LeadClient;
class LoggingClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.LogError = (log, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/LogError`, log, undefined, config);
        };
    }
}
exports.LoggingClient = LoggingClient;
class MissingDocumentClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Put = (id, missingDocument, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, missingDocument, undefined, config);
        };
        this.GetAttachmentAsync = (missingDocumentId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${missingDocumentId}/Attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.GetPdf = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Pdf/${id}`, undefined, undefined, config);
        };
    }
}
exports.MissingDocumentClient = MissingDocumentClient;
class MonthlyReportsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.List = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Generate = (request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, request, undefined, config);
        };
        this.Regenerate = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/regenerate`, request, undefined, config);
        };
        this.EditMarkdown = (id, request, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}/markdown`, request, undefined, config);
        };
        this.Approve = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/approve`, undefined, undefined, config);
        };
        this.Unpublish = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/unpublish`, undefined, undefined, config);
        };
        this.GetCompanyInstruction = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CompanyInstruction`, undefined, undefined, config);
        };
        this.SaveCompanyInstruction = (request, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/CompanyInstruction`, request, undefined, config);
        };
    }
}
exports.MonthlyReportsClient = MonthlyReportsClient;
class NewsArticlesClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetLatest = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetLatest`, undefined, undefined, config);
        };
    }
}
exports.NewsArticlesClient = NewsArticlesClient;
class NotificationClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.SubscribeAsync = (subscription, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, subscription, undefined, config);
        };
        this.UpdateSubscriptionAsync = (subscription, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}`, subscription, undefined, config);
        };
        this.UnsubscribeAsync = (handle, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${handle}`, undefined, undefined, config);
        };
    }
}
exports.NotificationClient = NotificationClient;
class OffboardingBankIdAuthClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Begin = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/begin`, undefined, undefined, config);
        };
        this.Status = (signId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/status/${signId}`, undefined, undefined, config);
        };
    }
}
exports.OffboardingBankIdAuthClient = OffboardingBankIdAuthClient;
class OnboardingBankIdAuthClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Begin = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/begin`, undefined, undefined, config);
        };
        this.Status = (signId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/status/${signId}`, undefined, undefined, config);
        };
    }
}
exports.OnboardingBankIdAuthClient = OnboardingBankIdAuthClient;
class OnboardingTestSessionClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Create = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, undefined, undefined, config);
        };
    }
}
exports.OnboardingTestSessionClient = OnboardingTestSessionClient;
class PaymentClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.UnhandledBankPayments = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/UnhandledBankPayments`, undefined, undefined, config);
        };
        this.SignUnhandledBankPayments = (payment, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/SignUnhandledBankPayments`, payment, undefined, config);
        };
    }
}
exports.PaymentClient = PaymentClient;
class PingClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, undefined, undefined, config);
        };
    }
}
exports.PingClient = PingClient;
class PreliminaryTaxUpdateClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Accept = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Accept`, undefined, undefined, config);
        };
        this.Decline = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Decline`, undefined, undefined, config);
        };
    }
}
exports.PreliminaryTaxUpdateClient = PreliminaryTaxUpdateClient;
class ProfileImagesClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
    }
}
exports.ProfileImagesClient = ProfileImagesClient;
class ProfileRoutineClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Put = (id, profileRoutine, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, profileRoutine, undefined, config);
        };
    }
}
exports.ProfileRoutineClient = ProfileRoutineClient;
class QualifiedShareDividendClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Filter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetCalculatedValues = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/CalculatedValues`, undefined, undefined, config);
        };
        this.Approve = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Approve`, undefined, undefined, config);
        };
        this.Reject = (id, reject, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Reject`, reject, undefined, config);
        };
        this.DownloadPdf = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/DownloadPdf`, undefined, undefined, config);
        };
        this.GetShareholderDividendsInfoAsync = (financialYearId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${financialYearId}/ShareHolderDividends`, undefined, undefined, config);
        };
    }
}
exports.QualifiedShareDividendClient = QualifiedShareDividendClient;
class QuotationClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Post = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, post, undefined, config);
        };
        this.SetStatus = (id, post, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/status/${id}`, post, undefined, config);
        };
        this.Edit = (id, post, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/edit/${id}`, post, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.Cancel = (id, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/delete/${id}`, undefined, undefined, config);
        };
        this.SendMail = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/mail`, post, undefined, config);
        };
        this.DownloadQuotationPdf = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/download/${id}`, undefined, undefined, config);
        };
        this.GetAttachment = (id, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.RemoveAttachment = (id, attachmentId, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}/attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.GetStateLogs = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/StateLogs/${id}`, undefined, undefined, config);
        };
        this.GetDefaultMailOptions = (request, serialNo, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DefaultMailOptions/${serialNo}`, request, undefined, config);
        };
        this.MarkAsSent = (serialNo, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/MarkAsSent/${serialNo}`, undefined, undefined, config);
        };
        this.DownloadPdf = (serialNumber, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DownloadPDF/${serialNumber}`, undefined, undefined, config);
        };
        this.PreviewQuotationPdf = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Preview`, post, undefined, config);
        };
        this.PreviewInlineQuotationPdf = (serialNo, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${serialNo}/Preview`, undefined, undefined, config);
        };
        this.CreateInvoice = (serialNo, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${serialNo}/CreateInvoice`, undefined, undefined, config);
        };
        this.UpdateDimensions = (serialNo, dimensionPut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${serialNo}/UpdateDimension`, dimensionPut, undefined, config);
        };
        this.GetCopiedQuotation = (serialNo, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${serialNo}/Copy`, undefined, undefined, config);
        };
    }
}
exports.QuotationClient = QuotationClient;
class ReceiptCategoryClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.ReceiptCategoryClient = ReceiptCategoryClient;
class ReceiptClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.Post = (receipt, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, receipt, undefined, config);
        };
        this.Put = (id, receipt, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, receipt, undefined, config);
        };
        this.Cancel = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Cancel/${id}`, undefined, undefined, config);
        };
        this.Sign = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Sign/${id}`, undefined, undefined, config);
        };
        this.UpdateAndSign = (id, receipt, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/UpdateAndSign/${id}`, receipt, undefined, config);
        };
        this.SendBack = (id, data, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SendBack/${id}`, data, undefined, config);
        };
        this.GetAttachmentAsync = (receiptId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${receiptId}/Attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.DeleteImageAsync = (receiptId, imageId, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${receiptId}/Images/${imageId}`, undefined, undefined, config);
        };
        this.GetAllReceiptPersonsAsync = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AllReceiptPersons`, undefined, undefined, config);
        };
        this.GetCommonReceiptPersonsAsync = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CommonReceiptPersons`, undefined, undefined, config);
        };
        this.AddReceiptPersonsAsync = (receiptPerson, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/AddReceiptPerson`, receiptPerson, undefined, config);
        };
        this.RemoveReceiptPersonsAsync = (personId, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/RemoveReceiptPerson/${personId}`, undefined, undefined, config);
        };
        this.GetPdfAsync = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetPdfAsync/${id}`, undefined, undefined, config);
        };
        this.FindSimilarAsync = (id, limit, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SimilarAsync/${id}`, { limit: limit }, undefined, config);
        };
        this.GetTransactions = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Transactions/${id}`, undefined, undefined, config);
        };
        this.GetStateLogs = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/StateLogs/${id}`, undefined, undefined, config);
        };
        this.GetCanReceivePayouts = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CanReceivePayouts`, undefined, undefined, config);
        };
        this.GetDimensionSuggestions = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DimensionSuggestions`, undefined, undefined, config);
        };
        this.HandleDocumentDraft = (receiptDocumentDraft, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/HandleDocumentDraft`, receiptDocumentDraft, undefined, config);
        };
        this.GetWintCardSuppliers = (searchTerm, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/WintCardSuppliers`, { searchTerm: searchTerm }, undefined, config);
        };
        this.GetTopWintCardSuppliers = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/TopWintCardSuppliers`, undefined, undefined, config);
        };
    }
}
exports.ReceiptClient = ReceiptClient;
class ReceiptPaymentMethodClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetByPaymentmethodid = (paymentMethodId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${paymentMethodId}`, undefined, undefined, config);
        };
        this.Post = (receiptPaymentMethod, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, receiptPaymentMethod, undefined, config);
        };
        this.Update = (paymentMethodId, receiptPaymentMethod, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${paymentMethodId}`, receiptPaymentMethod, undefined, config);
        };
        this.GetTopPaymentMethods = (count, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/TopPaymentMethods`, { count: count }, undefined, config);
        };
    }
}
exports.ReceiptPaymentMethodClient = ReceiptPaymentMethodClient;
class ReceiptReportClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
    }
}
exports.ReceiptReportClient = ReceiptReportClient;
class RecurringInvoiceClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.Post = (recurringInvoice, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, recurringInvoice, undefined, config);
        };
        this.Update = (id, recurringInvoice, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, recurringInvoice, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Start = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Start`, undefined, undefined, config);
        };
        this.Stop = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Stop`, undefined, undefined, config);
        };
        this.GetStateLogs = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/StateLogs/${id}`, undefined, undefined, config);
        };
        this.GetCopiedRecurringInvoice = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Copy`, undefined, undefined, config);
        };
    }
}
exports.RecurringInvoiceClient = RecurringInvoiceClient;
class ReferenceClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.Post = (reference, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, reference, undefined, config);
        };
        this.Put = (id, reference, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, reference, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetSearchReferencePersons = (customerId, searchString, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SearchByName`, { customerId: customerId, searchString: searchString }, undefined, config);
        };
        this.GetSearchReferencePersonsByMail = (customerId, searchString, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SearchByMail`, { customerId: customerId, searchString: searchString }, undefined, config);
        };
        this.GetTopReferencePersons = (customerId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Common`, { customerId: customerId }, undefined, config);
        };
    }
}
exports.ReferenceClient = ReferenceClient;
class ReportClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.Get2 = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Get`, filter, undefined, config);
        };
    }
}
exports.ReportClient = ReportClient;
class ReportWidgetClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetByFilter = (id, jsonContent, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/filter/${id}`, jsonContent, undefined, config);
        };
        this.Get = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, undefined, undefined, config);
        };
    }
}
exports.ReportWidgetClient = ReportWidgetClient;
class RevenueReportingClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetTemplates = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/templates`, undefined, undefined, config);
        };
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetAttachment = (id, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/attachment/${attachmentId !== undefined ? attachmentId : ''}`, undefined, undefined, config);
        };
        this.GetTransactions = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/transactions`, undefined, undefined, config);
        };
        this.Post = (dto, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, dto, undefined, config);
        };
        this.Approve = (request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/approve`, request, undefined, config);
        };
        this.GetApprovals = (templateId, year, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/approvals`, { templateId: templateId, year: year }, undefined, config);
        };
        this.GetApprovalAttachment = (templateId, periodYear, periodMonth, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${templateId}/${periodYear}/${periodMonth}/approval-attachment`, undefined, undefined, config);
        };
    }
}
exports.RevenueReportingClient = RevenueReportingClient;
class SalaryClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.FilterGrossSalaries = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GrossSalaries`, filter, undefined, config);
        };
    }
}
exports.SalaryClient = SalaryClient;
class SalaryDeviationClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetMonths = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/months`, filter, undefined, config);
        };
        this.GetMonth = (yearMonth, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/months/${yearMonth}`, undefined, undefined, config);
        };
        this.SubmitReport = (data, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SubmitReport`, data, undefined, config);
        };
        this.GetDeviations = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetDeviation = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Post = (salaryDeviationPost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, salaryDeviationPost, undefined, config);
        };
        this.CreateWithValidationSummary = (salaryDeviationPost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Create`, salaryDeviationPost, undefined, config);
        };
        this.Put = (salaryDeviationPut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}`, salaryDeviationPut, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetPersonMonthlySalaryDeviations = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/PersonMonthlySalaryDeviations`, filter, undefined, config);
        };
    }
}
exports.SalaryDeviationClient = SalaryDeviationClient;
class SalaryImportClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Post = (file, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, file, undefined, config);
        };
    }
}
exports.SalaryImportClient = SalaryImportClient;
class SalarySpecificationDocumentClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, undefined, undefined, config);
        };
        this.Filter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Filter`, filter, undefined, config);
        };
        this.FilterAll = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/FilterAll`, filter, undefined, config);
        };
        this.GetSalarySpecificationsUsers = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetSalarySpecificationsUsers`, undefined, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Download = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Download`, undefined, undefined, config);
        };
        this.GenerateSalarySpec = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Generate`, undefined, undefined, config);
        };
    }
}
exports.SalarySpecificationDocumentClient = SalarySpecificationDocumentClient;
class SearchClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.SearchClient = SearchClient;
class SelfInvoiceClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetUnhandledSelfInvoicesAsync = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, undefined, undefined, config);
        };
        this.GetAsync = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/id`, { id: id }, undefined, config);
        };
        this.MarkSelfInvoiceAsRejectedAsync = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/mark-rejected`, undefined, undefined, config);
        };
        this.MarkSelfInvoiceAsCreatedAsync = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/mark-created`, undefined, undefined, config);
        };
        this.Post = (selfInvoicePost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, selfInvoicePost, undefined, config);
        };
        this.GetTemplateInvoiceFromSelfInvoiceAsync = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/template-invoice`, undefined, undefined, config);
        };
        this.GetCustomerInvoiceId = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/customer-invoice-id`, undefined, undefined, config);
        };
    }
}
exports.SelfInvoiceClient = SelfInvoiceClient;
class SeriesClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.SeriesClient = SeriesClient;
class SettingsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.EmployeeSettings = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Employee`, undefined, undefined, config);
        };
        this.UpdateEmployeeSettings = (settings, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Employee`, settings, undefined, config);
        };
        this.DimensionSettings = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Dimension`, undefined, undefined, config);
        };
        this.UpdateDimensionSettings = (setting, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Dimension`, setting, undefined, config);
        };
        this.InvoiceSettings = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Invoice`, undefined, undefined, config);
        };
        this.ProfileSettings = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Profile`, undefined, undefined, config);
        };
        this.UpdateProfileSettings = (settings, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Profile`, settings, undefined, config);
        };
        this.CompanySettings = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Company`, undefined, undefined, config);
        };
        this.UpdateInvoiceSettings = (invoiceSettingsPut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Invoice`, invoiceSettingsPut, undefined, config);
        };
        this.UpdateCompanySettings = (companySettings, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Company`, companySettings, undefined, config);
        };
        this.UpdateSalary = (id, salarySettingsput, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Employee/${id}/Salary`, salarySettingsput, undefined, config);
        };
        this.UpdateSalaries = (salarySettings, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Employee/Salaries`, salarySettings, undefined, config);
        };
        this.ActivateSalary = (employeeId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Employee/${employeeId}/ActivateSalary`, undefined, undefined, config);
        };
        this.InactivateSalary = (employeeId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Employee/${employeeId}/InactivateSalary`, undefined, undefined, config);
        };
        this.GetApps = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Integration/Apps`, undefined, undefined, config);
        };
        this.SaveBillogram = (settings, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Integration/Billogram`, settings, undefined, config);
        };
        this.SaveJobbile = (settings, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Integration/Jobbile`, settings, undefined, config);
        };
        this.SaveQbis = (settings, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Integration/Qbis`, settings, undefined, config);
        };
        this.UpdateCustomApp = (id, settings, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Integration/CustomApp/${id}`, settings, undefined, config);
        };
        this.CreateCustomApp = (settings, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Integration/CustomApp`, settings, undefined, config);
        };
        this.GenerateCustomAppAPIKey = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Integration/GenerateCustomAppKey`, undefined, undefined, config);
        };
        this.DeleteCustomApp = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/Integration/CustomApp/${id}`, undefined, undefined, config);
        };
    }
}
exports.SettingsClient = SettingsClient;
class ShareRegisterClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetAsync = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, undefined, undefined, config);
        };
        this.GetOwnersAsync = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/owners`, undefined, undefined, config);
        };
        this.GetOwnersAndSharesAsync = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/OwnersAndShares`, filter, undefined, config);
        };
        this.GetOwnerAsync = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/owners/${id}`, undefined, undefined, config);
        };
        this.CreateOwnerAsync = (owner, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/owners`, owner, undefined, config);
        };
        this.GetEventAsync = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/events/${id}`, undefined, undefined, config);
        };
        this.CreateTransactionAsync = (transaction, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/events/transaction`, transaction, undefined, config);
        };
        this.CreateArrangementAsync = (arrangement, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/events/arrangement`, arrangement, undefined, config);
        };
        this.DeleteEventAsync = (eventId, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}`, { eventId: eventId }, undefined, config);
        };
        this.ExportAsync = (snapshot, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/export/${snapshot}`, undefined, undefined, config);
        };
        this.Approve = (id, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Approve`, undefined, undefined, config);
        };
        this.Reject = (id, reject, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Reject`, reject, undefined, config);
        };
        this.GetIsOwnershipInformationAvailable = (request, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/IsOwnershipInformationAvailable`, request, undefined, config);
        };
        this.GetCompanyHoldingsAsync = (request, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CompanyHoldings`, request, undefined, config);
        };
    }
}
exports.ShareRegisterClient = ShareRegisterClient;
class SkattekontoClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetAsync = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, undefined, undefined, config);
        };
    }
}
exports.SkattekontoClient = SkattekontoClient;
class StoppedPaymentClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetStoppedPaymentsInfo = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/StoppedPaymentsInfo`, undefined, undefined, config);
        };
        this.RescheduleStoppedPayments = (request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Reschedule`, request, undefined, config);
        };
    }
}
exports.StoppedPaymentClient = StoppedPaymentClient;
class SupplementaryMaterialsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Put = (id, supplementaryMaterial, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, supplementaryMaterial, undefined, config);
        };
    }
}
exports.SupplementaryMaterialsClient = SupplementaryMaterialsClient;
class SupportAgentClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.CreateSession = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Sessions`, undefined, undefined, config);
        };
        this.SendMessage = (sessionId, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Sessions/${sessionId}/Messages`, request, undefined, config);
        };
        this.CreateCase = (sessionId, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Sessions/${sessionId}/Case`, request, undefined, config);
        };
        this.SummarizeCase = (sessionId, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Sessions/${sessionId}/CaseSummary`, request, undefined, config);
        };
    }
}
exports.SupportAgentClient = SupportAgentClient;
class SupportCategoryClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetAsyncById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetAsyncByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetOptionsAsync = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Options`, undefined, undefined, config);
        };
    }
}
exports.SupportCategoryClient = SupportCategoryClient;
class SupportClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetComments = (issueId, filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${issueId}/Comments`, filter, undefined, config);
        };
        this.AddCommentAsync = (issueId, post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${issueId}/Comments`, post, undefined, config);
        };
        this.GetAttachmentAsync = (issueId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${issueId}/Attachments/${attachmentId}`, undefined, undefined, config);
        };
        this.GetAttachmentAsImageAsync = (issueId, attachmentId, page, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${issueId}/Attachments/${attachmentId}/Image`, { page: page }, undefined, config);
        };
        this.DownloadAttachment = (issueId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${issueId}/DownloadAttachment/${attachmentId}`, undefined, undefined, config);
        };
        this.ExportConversationAsync = (issueId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${issueId}/Export`, undefined, undefined, config);
        };
        this.GetAttachmentPageCountAsync = (issueId, attachmentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${issueId}/Attachments/${attachmentId}/Pages`, undefined, undefined, config);
        };
        this.GetAsync = (issueId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${issueId}`, undefined, undefined, config);
        };
        this.Filter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.ListItems = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/ListItems`, filter, undefined, config);
        };
        this.PostAsync = (issue, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, issue, undefined, config);
        };
        this.ResolveAsync = (issueId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${issueId}/Resolve`, undefined, undefined, config);
        };
        this.UnresolveAsync = (issueId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${issueId}/Unresolve`, undefined, undefined, config);
        };
        this.SendToAsync = (issueId, employeeId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${issueId}/SendTo/${employeeId}`, undefined, undefined, config);
        };
        this.AgencyForwardAsync = (issueId, target, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${issueId}/AgencyForward`, target, undefined, config);
        };
        this.GetAgencyForwardTargets = (issueId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${issueId}/AgencyForwardTargets`, undefined, undefined, config);
        };
        this.ConfirmAsync = (issueId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${issueId}/Confirm`, undefined, undefined, config);
        };
        this.GetCommentRatingAsync = (commentId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CustomerCase/Post/${commentId}/Rating`, undefined, undefined, config);
        };
        this.AddCommentRatingAsync = (commentId, rating, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/CustomerCase/Post/${commentId}/Rating`, rating, undefined, config);
        };
        this.DeleteCommentRatingAsync = (commentId, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/CustomerCase/Post/${commentId}/Rating`, undefined, undefined, config);
        };
        this.GetSuggestedSupportPersons = (request, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetSuggestedSupportPersons`, request, undefined, config);
        };
    }
}
exports.SupportClient = SupportClient;
class SupportTeamClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (companyId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${companyId}`, undefined, undefined, config);
        };
    }
}
exports.SupportTeamClient = SupportTeamClient;
class SurveyClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.SaveResponse = (response, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/surveyResponses`, response, undefined, config);
        };
        this.GetSurveyStatus = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/Status`, undefined, undefined, config);
        };
        this.CreateSurveyCustomerCase = (config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/{id}/SurveyCustomerCase`, undefined, undefined, config);
        };
        this.AddSurveyComment = (id, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/comments`, request, undefined, config);
        };
        this.SendToPerson = (id, request, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}/send`, request, undefined, config);
        };
        this.GetSurveyPersons = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetSurveyPersons`, filter, undefined, config);
        };
        this.GetSurveyPersonSuggestions = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetSurveyPersonSuggestions`, filter, undefined, config);
        };
        this.GetAttachment = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/attachment/${id}`, undefined, undefined, config);
        };
    }
}
exports.SurveyClient = SurveyClient;
class TimeReportClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Report = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Report`, filter, undefined, config);
        };
        this.Export = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Export`, filter, undefined, config);
        };
        this.Filter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Filter`, filter, undefined, config);
        };
        this.MergeTimeReport = (timeReportMetaDataWithPeriods, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/MergeTimeReport`, timeReportMetaDataWithPeriods, undefined, config);
        };
        this.GetStatusByDateRange = (employeeId, startDate, endDate, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Status`, { employeeId: employeeId, startDate: startDate, endDate: endDate }, undefined, config);
        };
        this.UpdateStatusByDateRange = (updateStatusByRange, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/Status`, updateStatusByRange, undefined, config);
        };
        this.GetCompensationTime = (employeeId, year, month, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CompTime`, { employeeId: employeeId, year: year, month: month }, undefined, config);
        };
        this.CreateCompTime = (compTimePost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/CompTime`, compTimePost, undefined, config);
        };
        this.SubmitReport = (reportData, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SubmitReport`, reportData, undefined, config);
        };
        this.GetDueMonthReport = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetDueMonthReport`, undefined, undefined, config);
        };
        this.Comments = (projectTimeId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Comments/${projectTimeId}`, undefined, undefined, config);
        };
    }
}
exports.TimeReportClient = TimeReportClient;
class TimeReportingProjectClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Report = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Report`, filter, undefined, config);
        };
        this.DuplicateNameCheck = (projectName, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DuplicateNameCheck`, { projectName: projectName }, undefined, config);
        };
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.AvailableProjectManagers = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AvailableProjectManagers`, filter, undefined, config);
        };
        this.AvailableProjectMembers = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/AvailableProjectMembers`, filter, undefined, config);
        };
        this.Post = (projectPost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, projectPost, undefined, config);
        };
        this.Put = (id, projectPut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}`, projectPut, undefined, config);
        };
        this.Invoice = (id, invoiceDocumentation, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/Invoice`, invoiceDocumentation, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.HasUnInvoicedProjectTime = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/HasUnInvoicedProjectTime`, undefined, undefined, config);
        };
        this.Inactivate = (id, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${id}/Inactivate`, undefined, undefined, config);
        };
        this.Categories = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Categories`, filter, undefined, config);
        };
        this.ConnectInvoice = (id, invoiceDocumentation, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/${id}/ConnectInvoice`, invoiceDocumentation, undefined, config);
        };
    }
}
exports.TimeReportingProjectClient = TimeReportingProjectClient;
class TodoClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.SnoozeByIdasinteger = (idAsInteger, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Snooze/${idAsInteger}`, request, undefined, config);
        };
        this.SnoozeByIdasguid = (idAsGuid, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Snooze/${idAsGuid}`, request, undefined, config);
        };
        this.TodoSummary = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/TodoSummary`, filter, undefined, config);
        };
    }
}
exports.TodoClient = TodoClient;
class TransactionClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetSeries = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Series`, undefined, undefined, config);
        };
        this.GetCategories = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Categories`, undefined, undefined, config);
        };
    }
}
exports.TransactionClient = TransactionClient;
class UnitClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Post = (unit, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, unit, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
    }
}
exports.UnitClient = UnitClient;
class UserApiKeyClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.RevokeCurrentKey = (config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/key`, undefined, undefined, config);
        };
        this.RevokeAllKeys = (config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/keys`, undefined, undefined, config);
        };
    }
}
exports.UserApiKeyClient = UserApiKeyClient;
class UserClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.MarkIntroductionAsShown = (introductionId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/MarkIntroductionAsShown`, introductionId, undefined, config);
        };
        this.MarkHelpAsShown = (helpId, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/MarkHelpAsShown`, helpId, undefined, config);
        };
        this.SignEula = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SignEula`, undefined, undefined, config);
        };
        this.SuspendEulaSigning = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/SuspendEulaSigning`, undefined, undefined, config);
        };
        this.GetProfileToggles = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/ProfileToggles`, undefined, undefined, config);
        };
        this.UpdateDefaultTodoGroupType = (todoGroupType, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/DefaultTodoGroupType`, todoGroupType, undefined, config);
        };
        this.GetDefaultTodoGroupType = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DefaultTodoGroupType`, undefined, undefined, config);
        };
        this.GetUploadedReceiptCount = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/UploadedReceiptCount`, undefined, undefined, config);
        };
    }
}
exports.UserClient = UserClient;
class UtilsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.ValidateOrgNumber = (request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/ValidateOrgNumber`, request, undefined, config);
        };
    }
}
exports.UtilsClient = UtilsClient;
class VatReportsClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetAvailability = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Available`, undefined, undefined, config);
        };
        this.List = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
    }
}
exports.VatReportsClient = VatReportsClient;
class VoucherClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetById = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Post = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, post, undefined, config);
        };
        this.Post2 = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Post`, post, undefined, config);
        };
        this.GetByFilter = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.VoucherClient = VoucherClient;
class VoucherImagesClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.Post = (voucherImage, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, voucherImage, undefined, config);
        };
        this.Delete = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${id}`, undefined, undefined, config);
        };
        this.GetPdf = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${id}/DownloadPDF`, undefined, undefined, config);
        };
    }
}
exports.VoucherImagesClient = VoucherImagesClient;
class WarmUpClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetAsync = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, undefined, undefined, config);
        };
    }
}
exports.WarmUpClient = WarmUpClient;
class WintCardClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.RequestWintCardRegistration = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/RequestRegistration`, undefined, undefined, config);
        };
        this.RejectWintCardRegistration = (config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/RejectRegistration`, undefined, undefined, config);
        };
    }
}
exports.WintCardClient = WintCardClient;
class WintSalaryCommissionClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetTransactions = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.WintSalaryCommissionClient = WintSalaryCommissionClient;
class WintSalaryClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.ApproveSalaryMonth = (approvalData, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/Approve`, approvalData, undefined, config);
        };
        this.GetDueMonthSalaryApprovalReport = (config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/ApprovalReport`, undefined, undefined, config);
        };
        this.SearchPersons = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SearchPersons`, filter, undefined, config);
        };
        this.SalaryReport = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/SalaryReport`, filter, undefined, config);
        };
        this.GetPayslip = (personId, yearMonth, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/Payslip/${personId}/yearMonth/${yearMonth}`, undefined, undefined, config);
        };
        this.CalculateGrossSalaryWithTarget = (personId, yearMonth, targetGrossSalaryAmount, useOneTimeTax, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/CalculateGrossSalaryWithTarget/${personId}/yearMonth/${yearMonth}`, { targetGrossSalaryAmount: targetGrossSalaryAmount, useOneTimeTax: useOneTimeTax }, undefined, config);
        };
        this.UpdateTargetGrossSalaryAmount = (personId, yearMonth, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/UpdateTargetGrossSalaryAmount/${personId}/yearMonth/${yearMonth}`, request, undefined, config);
        };
        this.GetMinimumTargetGrossSalaryAmount = (personId, yearMonth, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/GetMinimumTargetGrossSalaryAmount/${personId}/yearMonth/${yearMonth}`, undefined, undefined, config);
        };
        this.GetPersonSalaryReport = (personId, yearMonth, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/PersonReport/${personId}/yearMonth/${yearMonth}`, undefined, undefined, config);
        };
        this.GetVacationYear = (personId, endDate, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/VacationYear/${personId}`, { endDate: endDate }, undefined, config);
        };
    }
}
exports.WintSalaryClient = WintSalaryClient;
class WintSalaryDeviationClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetDeviationTypes = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DeviationTypes`, filter, undefined, config);
        };
        this.GetDailyHoursTemplate = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DailyHoursTemplate`, filter, undefined, config);
        };
        this.CreateDeviation = (salaryDeviationPost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}`, salaryDeviationPost, undefined, config);
        };
        this.UpdateDeviation = (deviationId, salaryDeviationPut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/${deviationId}`, salaryDeviationPut, undefined, config);
        };
        this.DeleteDeviation = (deviationId, yearMonth, yearMonthTo, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/${deviationId}`, { yearMonth: yearMonth, yearMonthTo: yearMonthTo }, undefined, config);
        };
        this.CreateDeviationMutable = (salaryDeviationPost, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/mutable`, salaryDeviationPost, undefined, config);
        };
        this.UpdateDeviationMutable = (deviationId, salaryDeviationPut, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/mutable/${deviationId}`, salaryDeviationPut, undefined, config);
        };
        this.DeleteDeviationMutable = (deviationId, yearMonth, yearMonthTo, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/mutable/${deviationId}`, { yearMonth: yearMonth, yearMonthTo: yearMonthTo }, undefined, config);
        };
        this.GetDeviations = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
        this.GetDeviationsPaged = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/filter`, filter, undefined, config);
        };
        this.GetDeviation = (deviationId, yearMonth, yearMonthTo, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/${deviationId}`, { yearMonth: yearMonth, yearMonthTo: yearMonthTo }, undefined, config);
        };
        this.GetSalaryDeviationReport = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/DeviationReport`, filter, undefined, config);
        };
        this.GetChildrenForPerson = (personId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/persons/${personId}/children`, undefined, undefined, config);
        };
        this.CreateChildForPerson = (personId, request, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/persons/${personId}/children`, request, undefined, config);
        };
        this.GetWithdrawalBalances = (personId, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/persons/${personId}/withdrawalBalances`, undefined, undefined, config);
        };
    }
}
exports.WintSalaryDeviationClient = WintSalaryDeviationClient;
class AutomationRuleClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.Get = (filter, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}`, filter, undefined, config);
        };
    }
}
exports.AutomationRuleClient = AutomationRuleClient;
class ReceiptAutomationRuleClient extends baseClient_1.BaseClient {
    constructor() {
        super(...arguments);
        this.GetWintCardRule = (id, config) => {
            return (0, baseClient_1.httpGet)(`${this.url}/WintCardRule/${id}`, undefined, undefined, config);
        };
        this.CreateWintCardRule = (post, config) => {
            return (0, baseClient_1.httpPost)(`${this.url}/WintCardRule`, post, undefined, config);
        };
        this.UpdateWintCardRule = (id, put, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/WintCardRule/${id}`, put, undefined, config);
        };
        this.DeleteWintCardRule = (id, config) => {
            return (0, baseClient_1.httpDelete)(`${this.url}/WintCardRule/${id}`, undefined, undefined, config);
        };
        this.ActivateWintCardRule = (id, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/WintCardRule/${id}/Activate`, undefined, undefined, config);
        };
        this.DeactivateWintCardRule = (id, config) => {
            return (0, baseClient_1.httpPut)(`${this.url}/WintCardRule/${id}/Deactivate`, undefined, undefined, config);
        };
    }
}
exports.ReceiptAutomationRuleClient = ReceiptAutomationRuleClient;
